import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "src/store/rootReducer";

export const selectModelData = createSelector(
  [(state: RootState, modelName: string) => {
    return state.gosStrapi.filtersData[modelName]?.data;
  }],
  (data) => {
    return data || [];
  }
);

export const selectModelLoading = createSelector(
  [(state: RootState, modelName: string) => state.gosStrapi.filtersData[modelName]?.loading],
  (loading) => loading || false
);

export const selectModelError = createSelector(
  [(state: RootState, modelName: string) => state.gosStrapi.filtersData[modelName]?.error],
  (error) => error || null
);